import { Component } from 'react';
import DocumentViewer from 'part11/components/Document/DocumentViewer/DocumentViewer';

class IndexDocumentPreviewContainer extends Component {
    render() {
        const {
            document
        } = this.props;

        return <DocumentViewer document={document} />;
    }
}

export default IndexDocumentPreviewContainer;
